export default __webpack_public_path__ + "static/media/broken-screen.53502ca5.png";